import React from 'react'
import { Text } from 'components/ds'
type Props = {
  caption: string
  htmlFor?: string
  required?: boolean
}

/**
 * Label component for form fields in login forms
 * Styled label element with consistent typography and accessibility support
 * @param caption - Label text to display
 * @param htmlFor - ID of the associated form control
 * @param required - Whether to show a required-field indicator
 */
const Label = ({ caption, htmlFor, required }: Props): React.ReactNode => (
  <Text as="label" size="3" weight="medium" htmlFor={htmlFor}>
    {caption}
    {required && (
      <Text color="red" ml="1" aria-hidden="true">
        *
      </Text>
    )}
  </Text>
)

export default Label
